
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"weeklyStatFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WeeklyStat"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsOn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endsOn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billableHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonBillableHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklySpending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalSpending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"budget"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":155}};
    doc.loc.source = {"body":"fragment weeklyStatFields on WeeklyStat {\n  id\n  number\n  startsOn\n  endsOn\n  billableHours\n  nonBillableHours\n  weeklySpending\n  totalSpending\n  budget\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/weeklyStatFields.graphql
// module id = 303
// module chunks = 17